import React from "react";
import { Modal } from 'react-bootstrap';
import Button from "../conditional-button";
class ExModal extends React.Component { 

    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }

    get buttons() {        
        return (this.props.buttons ?? []).map((item, index) => {
            // pull out the props you *don’t* want to forward
            const {
                caption,
                default: isDefault, // keep for onHideModal logic (not forwarded)
                variant = "secondary",
                display = true,
                enabled = true,
                onClick,
                ...forwardProps // everything else gets forwarded to <Button />
            } = item;

            return (
                <Button
                    key={`modal_button_${index}`}
                    display={display}
                    enabled={enabled}
                    enabledVariant={variant}
                    onEnabledClick={onClick}
                    {...forwardProps}
                >
                    {caption}
                </Button>
            );
        });
    }

    onHideModal = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
            this.setState({
                show: false
            });
            return;
        }

        const buttons = this.props.buttons ?? [];
        let __default_items = buttons.filter(item => item.default);
        if (__default_items.length === 0 && buttons.length === 1) {
            const caption = `${buttons[0]?.caption ?? ""}`.trim().toLowerCase();
            if (["cancel", "close", "ok"].includes(caption)) {
                __default_items = buttons;
            }
        }

        __default_items.forEach((item) => {
            const handler = item.onEnabledClick ?? item.onClick;
            if (handler) handler();
        });
        this.setState({
            show: false
        });
    }

    render() {
        if (!this.props.show) {
            return <></>
        }
        return (
            <Modal size={this.props.size ?? "md"} className={this.props.className} backdrop="static" keyboard show={this.props.show} onHide={this.onHideModal}>
                <Modal.Header closeButton>
                    <Modal.Title id="staticBackdropLabel">{this.props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{this.props.body}{this.props.children}</Modal.Body>
                <Modal.Footer>
                    {this.buttons}
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ExModal;
